import { render, staticRenderFns } from "./productListWX.vue?vue&type=template&id=67459f20&"
import script from "./productListWX.vue?vue&type=script&lang=js&"
export * from "./productListWX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports